module.exports = __webpack_public_path__ + "static/media/dydx.83b7f122.svg";